(function () {
    'use strict';

    angular.module('swif.achats')
    .config(router)
    .controller('AchatsBudgetsController', AchatsBudgetsController)

    function router ($routeProvider) {
        'ngInject';
        $routeProvider.when('/achats-stocks/budgets/table_view', {
            templateUrl: 'partials/achats/crossovered_budget_table_view.html',
            controller: 'AchatsBudgetsController',
            resolve: {
                data: ['AchatsBudgetsService', function (service) {
                    return service.budgets.resolveData();
                }]
            },
            reloadOnSearch: false
        });
    }



    function AchatsBudgetsController ($scope, swif, data, AchatsBudgetsService) {
        'ngInject';
        console.log('init AchatsBudgetsController');
        $scope.budgets = data.budgets;
        $scope.lines = data.lines || undefined;
        $scope.callback = AchatsBudgetsService.budgets.callback;

        $scope.$watch('budgets.currentItem', function (newV, oldV) {
            if (newV && !angular.equals(newV,oldV)) {
                AchatsBudgetsService.budgetLines.createCollection(newV.id)
                .then(function (collection) {
                    if (!$scope.lines) {
                        $scope.lines = collection;
                    }
                });
            }
        });
    }
})();
